import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MdClose } from 'react-icons/md';
const Chip = ({ label, onRemove = null }) => {
    return (_jsxs("div", { role: "button", className: "h-8 px-3 w-max mb-1 mr-1 flex gap-2 items-center rounded-full text-wfGray-800 bg-wfGray-200", children: [_jsx("span", { className: "block text-sm font-medium", children: label }), onRemove ? (_jsx("div", { onClick: onRemove, role: "button", children: _jsx(MdClose, {}) })) : null] }));
};
export default Chip;
